import { Button, Tooltip } from 'antd'
import { ClockCircleOutlined } from '@ant-design/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../auth'

const STORAGE_KEY = 'showCandidateTimestamp'

export function timestampVisible() {
    return localStorage.getItem(STORAGE_KEY) === 'true'
}

export function CandidateTimestampToggle() {
    const { t } = useTranslation()

    const { showCandidateTimestamp, setShowCandidateTimestamp } = useAuth()

    return (
        <Tooltip title={showCandidateTimestamp ? t('Hide conversation date') : t('Show conversation date')}>
            <Button
                type="text"
                onClick={() => {
                    localStorage.setItem(STORAGE_KEY, `${!showCandidateTimestamp}`)
                    setShowCandidateTimestamp(!showCandidateTimestamp)
                }}
                icon={<ClockCircleOutlined />}
            />
        </Tooltip>
    )
}
